/**
 * @method getIndices
 * @param {Set} markerSet - set of object with an 'index' key which need to be extracted to a set.
 * @returns {Set}
 */
const getIndices = (markerSet) => {
  const indexSet = new Set();

  markerSet?.forEach((item) => {
    if (item.index || item.index === 0) {
      indexSet.add(item.index);
    }
  });

  return indexSet;
};

export default getIndices;
